import React from 'react';
import { ListOrderedIcon, LayersIcon, UsersIcon, PrinterIcon } from 'lucide-react';

/** The 4-Block Practice System — mecanismo con nombre (ficha DPS-33). */
const blocks = [{
  n: '1',
  name: 'Warm-Up & Throw',
  body: 'Every plan opens with its own warm-up and throwing progression. Arms ready, nothing to look up.',
  band: 'bg-ice'
}, {
  n: '2',
  name: 'Skill Build',
  body: 'One skill, a few focused drills, real reps — written out with distances, reps and rotations.',
  band: 'bg-clay'
}, {
  n: '3',
  name: 'Game Situations',
  body: 'The skill goes live in a game-like rep, so it actually shows up on game day.',
  band: 'bg-green'
}, {
  n: '4',
  name: 'Compete & Close',
  body: 'A competitive finish the team looks forward to — and the same clean ending every time.',
  band: 'bg-gold'
}];
const coverage = [{
  label: 'Right order',
  body: 'Foundations → defense → hitting → baserunning → team plays → game day',
  Icon: ListOrderedIcon
}, {
  label: 'Any age',
  body: 'Each practice in three levels: 6U–8U, 10U–12U, HS & rec',
  Icon: LayersIcon
}, {
  label: 'No dead time',
  body: 'Stations so nobody is standing in line waiting for a rep',
  Icon: UsersIcon
}, {
  label: 'Printable',
  body: 'Practice sheets, worksheets and a field card for every volume',
  Icon: PrinterIcon
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-navy-mid" data-id="element-252" data-mp="s4fzsps1ojh9">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-253" data-mp="1131bq230h092">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-254" data-mp="1154dfjdj0htm">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-white text-4xl sm:text-5xl" data-id="element-255" data-mp="2ci6sg9zz8zbo">
          The 4-Block Practice System
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-256" data-mp="1rsckthokpjdh">
          Every practice is built from the same four blocks. You don’t design
          practice &mdash; you pick blocks already written for your age group
          and level, and snap them together. It’s not a stack of loose drills;
          it’s “what to run on Tuesday.”
        </p>

        <ol className="mt-9 grid gap-3 text-left sm:grid-cols-2 lg:grid-cols-4" data-id="element-257" data-mp="192e4keamgjyr">
          {blocks.map(block => <li key={block.n} className="relative overflow-hidden rounded-xl border border-navy-line bg-navy-card px-4 pb-5 pt-6" data-id="element-258" data-mp="143tfnb0tlmpm">
              <span className={`absolute inset-x-0 top-0 h-1.5 ${block.band}`} data-id="element-259" data-mp="1iu0px3gobzf8" />
              <span className="font-display text-[11px] tracking-[2px] text-white/55" data-id="element-260" data-mp="1e068k6ojjwjb">
                Block {block.n}
              </span>
              <h3 className="mt-1 font-display text-2xl leading-tight text-white" data-id="element-261" data-mp="ld1vdefaobwg">
                {block.name}
              </h3>
              <p className="mt-2 text-sm text-white/75" data-id="element-262" data-mp="2wz426jix2g5h">{block.body}</p>
            </li>)}
        </ol>

        <ul className="mt-4 grid gap-2.5 text-left sm:grid-cols-2" data-id="element-263" data-mp="31sggo0tvt6ki">
          {coverage.map(({
          label,
          body,
          Icon
        }) => <li key={label} className="flex items-start gap-3 rounded-lg border border-navy-line bg-white/5 px-4 py-3.5" data-id="element-264" data-mp="2mzwizfpi3rag">
              <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-md bg-gold/15 text-gold" data-id="element-265" data-mp="3fryaium1ba0q">
                <Icon className="h-4 w-4" aria-hidden="true" data-id="element-266" data-mp="3koydgwnl7wnm" />
              </span>
              <span data-id="element-267" data-mp="36pf82bm5uzf0">
                <span className="block text-[11px] font-bold uppercase tracking-widest text-gold" data-id="element-268" data-mp="36s1eg7xbf8vn">
                  {label}
                </span>
                <span className="mt-1 block text-sm text-white/85" data-id="element-269" data-mp="1vajuksz93401">{body}</span>
              </span>
            </li>)}
        </ul>

        <p className="chalk-note mt-8 text-2xl sm:text-3xl text-gold" data-id="element-270" data-mp="1zdq01yejgr5g">
          Pick the plan. Print it. Run it.
        </p>
      </div>
    </section>;
}